<template>
  <div class='aboutList container-flfluid'>
    <section class="banner">
      <img :src="newList.banner" />
    </section>
    <section class="news-title">
      <div class="w1200 columnbox">
        <h2 class="centerbox">{{ newList.newsTitle }}</h2>
        <h3 class="centerbox">{{ newList.newsTitleEn }}</h3>
      </div>
    </section>

    <section class="news-list">
      <div class="w1200 columnbox">
        <div class="list-ul">
          <a class="flexbox n-item align-center" v-for='(item, index) in list.slice((currentPage - 1) * pagesize, currentPage * pagesize)' :key='index'  @click="goAboutDetail(item.title)">
            <img :src="item.img">
            <div class="text centerbox columnbox">
              <span class="flexbox title">
                <h5>{{ item.title }}</h5>
              </span>
              <p class="des">{{ item.text }}</p>
              <span class="betweenbox bottom">
                了解详情>>
                <font>{{ item.time }}</font>
              </span>
            </div>
          </a>
        </div>
        <!-- pc端 -->
        <div class="paginationsLine pcStyle">
          <el-pagination  @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pagesize" background
            layout="prev, pager, next" :total="list.length">
          </el-pagination>
        </div>
        <!-- 移动端 -->
        <div class="paginationsLine phoneStyle">
          <el-pagination  @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pagesize" background
            layout="prev, pager, next" :total="list.length">
          </el-pagination>
        </div>
        <div style="display: flex;justify-content: space-between;">
          <a class="return-a centerbox" style="margin-right: 100px;" @click="backList()"><img src="../../assets/images/r-ico.png"> 返回关于我们</a>
        </div>
      </div>
    </section>
  </div>
</template>
  
  <script>
import axios from 'axios'
export default {
  metaInfo() {
    return {
      title: "公司动态-健新",
      meta: [
        { name: "keywords", content: "keyword1, keyword2, keyword3" },
        { name: "description", content: "Page description" },
      ],
    };
  },
  mounted() {
    // const element = getScrollParent(this.$el)
    // element.scrollTop = 0
  },
  data() {
    return {
      newList:{},
      currentPage: 1,
      pagesize: 5,
      list:[]
    }
  },
  created() {
    this.getNewList()
  },
  methods: {
    getNewList() {
      let data = {
        Title: "公司新闻列表",
        ForumTypeCode: "TYGSXW",
      };
      axios
        .post("api/Forum/GetDoc", { ...data })
        .then((res) => {
          if (res) {
           this.newList = JSON.parse(res.data.OutputData.Content)
           this.list = this.newList.newList
          } else {
            this.$message({
              type: "error",
              message: "请求数据失败",
            });
          }
        });
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
     goAboutDetail(name) {
      this.$router.push({
        name:"aboutDetail",
        query:{
            title:name
        }
      })
    },
    // 返回列表
        backList() {
      this.$router.push({
        name:"jxAbout",
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../assets/less/base.less";

.aboutList {
  width: 100%;
  line-height: 1.7;
  .banner {
    width: 100%;
    height: auto;

    img {
      max-width: 100%;
      border: none;
      font-size: 0;
      outline-width: 0PX;
      vertical-align: top;
      width: 100%;
      height: auto;
    }
  }
  .news-title {
    .w1200 {
      border-bottom: 1PX solid #d2d2d2;
    }
    h2 {
      background: #007edd;
      color: #fff;
    }
    h3 {
      color: #007edd;
    }
  }
  .news-list {
    .list-ul {
      .n-item {
        width: 100%;
      }
      .n-item>img {
        flex: none;
      }
      .n-item .text {
        height: 100%;
        border-bottom: 1PX dashed #d2d2d2;
      }
      .n-item:last-child .text {
        border-bottom: none;
      }
      .n-item .text span {
        width: 100%;
        color: #458cff;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .n-item .text span label.v-label {
        background: url(../../assets/images/label-v.png) center center no-repeat;
        background-size: cover;
        flex: none;
      }
      .n-item .text span font {
        color: #969696;
      }
      .n-item .text span.title h5 {
        font-weight: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #458cff;
        line-height: 3;
      }
      .n-item .text p.des {
        width: 100%;
        text-align: justify;
        line-height: 1.5;
        color: #888;
      }
      .n-item:hover span,
      .n-item:hover span.title h5 {
        color: #007edd;
      }
    }
  }
  .paginationsLine {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .pcStyle {
    .page-item:first-child:hover,
    .page-item:last-child:hover {
      border: 1PX solid #007edd;
    }
  } //  @media only screen and (min-width: 1200px) {
  @media only screen and (min-width: 960px) {
    .banner {
      padding-top: 130PX;
    }
    .news-title {
      .w1200 {
        margin-bottom: 10PX;
      }
      h2 {
        width: 200PX;
        height: 45PX;
        font-size: 22PX;
        margin-bottom: 16PX;
      }
      h3 {
        width: 200PX;
        height: 45PX;
        font-size: 22PX;
      }
    }
    .news-list {
      padding-bottom: 40PX;
      .list-ul {
        padding-top: 12PX;
        padding-bottom: 40PX;
        .n-item {
          height: 220PX;
        }
      }
      .list-ul .n-item>img {
        width: 300PX;
        height: 180PX;
        margin-right: 30PX;
      }
      .list-ul .n-item .text {
        width: calc(100%);
        padding-left: 36PX;
        padding-top: 24PX;
        padding-bottom: 24PX;
      }
      .list-ul .n-item .text span {
        font-size: 14PX;
      }
      .list-ul .n-item .text span label.v-label {
        width: 76PX;
        height: 24PX;
        margin-right: 10PX;
      }
      .list-ul .n-item .text span.title h5 {
        font-size: 24PX;
      }
      .list-ul .n-item .text p.des {
        font-size: 16PX;
        margin-bottom: 40PX;
      }
    }
    .pcStyle {
      display: flex;
    }
    .phoneStyle {
      display: none;
    }
  }


  @media screen and (max-width:959px) and (min-width:320px) {
    /deep/.el-pagination .btn-prev {
      height: 1.64rem;
      width: 2.84rem;
      font-size: 0.96rem;
      margin: 0 4PX;
      border: 1PX solid #333;
      border-radius: 20PX;
    }
    /deep/.el-pagination .btn-next {
      width: 4.04rem;
      height: 1.64rem;
      font-size: 0.96rem;
      margin: 0 4PX;
      border: 1PX solid #333;
      border-radius: 20PX;
    }
    /deep/.el-pagination button:disabled {
      border: 1PX solid #ccc !important;
    }
    .banner {
      padding-top: 3.52rem;
    }
    .news-title {
      .w1200 {
        margin-bottom: .72rem;
      }
      h2 {
        width: 9.6rem;
        height: 2.16rem;
        font-size: 1.04rem;
        margin-bottom: .8rem;
      }
      h3 {
        width: 9.6rem;
        height: 2.16rem;
        font-size: 1.04rem;
      }
    }
    .news-list {
      padding-bottom: 2rem;
      .list-ul {
        padding-top: .96rem;
        padding-bottom: 1.6rem;
        .n-item {
          height: auto;
        }
      }
      .list-ul .n-item {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-flow: column;
        flex-flow: column;
        margin-bottom: 1.44rem;
      }
      .list-ul .n-item>img {
        width: 100%;
        height: auto;
        margin-right: 0;
        margin-bottom: 0;
      }
      .list-ul .n-item .text {
        width: 100%;
        padding: .96rem 0;
        border-bottom: 1PX dashed #d2d2d2;
      }
      .list-ul .n-item .text span {
        font-size: .96rem;
      }
      .list-ul .n-item .text span label.v-label {
        width: 3.6rem;
        height: 1.2rem;
        margin-right: .48rem;
      }
      .list-ul .n-item .text span.title h5 {
        font-size: 1.12rem;
      }
      .list-ul .n-item .text p.des {
        font-size: .96rem;
        margin-bottom: 1.6rem;
      }
    }
    .pcStyle {
      display: none;
    }
    .phoneStyle {
      display: flex;
      margin-bottom: 1.6rem;
      .page-item:first-child {
        width: 2.84rem;
      }
    }
  }
}
</style>